import { render } from "./BaseInputFile.vue?vue&type=template&id=2b291dbb&scoped=true"
import script from "./BaseInputFile.vue?vue&type=script&lang=js"
export * from "./BaseInputFile.vue?vue&type=script&lang=js"

import "./BaseInputFile.vue?vue&type=style&index=0&id=2b291dbb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b291dbb"]])

export default __exports__